import Helper from '../../../models/Helper';

const URI = '/users/:id/paths';

/**
 * @desc Helper for users paths.
 */
class PathsHelper extends Helper {
  constructor(api) {
    super(api, URI);
  }

  /**
   * @desc Search for users paths.
   * @param {Number} userId Id of the user to fetch.
   * @param {PaginationOptions} [filters={}] Filters to use to find paths.
   * @return {Promise<Array<PathWithUserInformation>>} The promise handling the request.
   * @example
   * const userId = 5678;
   * const response = await myClient.helpers.learningActivity.paths.find(userId);
   * @example
   * const userId = 5678;
   * const filters = { start: 0, end: 5 };
   * const response = await myClient.helpers.learningActivity.paths.find(userId, filters);
   */
  find(userId, filters = {}) {
    const request = super.find(filters, false);

    request.setRouteParams({ id: userId });

    return request.execute();
  }

  /**
   * @desc Get projects of given user from given path.
   * @param {Number} userId Id of the user to fetch.
   * @param {Number} pathId Id of the path to fetch.
   * @return {Promise<Array<ProjectWithUserInformation>>} The promise handling the request.
   * @example
   * const userId = 5678;
   * const pathId = 1234;
   * const response = await myClient.helpers.learningActivity.paths.getProjects(userId, pathId);
   */
  getProjects(userId, pathId) {
    const request = super.get(userId, false);
    request.url += '/:pathId/projects';

    request.setRouteParams({ pathId });

    return request.execute();
  }
}

export default PathsHelper;
